import { render, staticRenderFns } from "./ss-comment-list.vue?vue&type=template&id=0b21037e&scoped=true&"
import script from "./ss-comment-list.vue?vue&type=script&lang=js&"
export * from "./ss-comment-list.vue?vue&type=script&lang=js&"
import style0 from "./ss-comment-list.vue?vue&type=style&index=0&id=0b21037e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21037e",
  null
  
)

export default component.exports